(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var video = document.getElementById("halfturnVideo");
  var toggle = document.getElementById("audioToggleButton");

  if (!video || !toggle) return;

  // start muted to satisfy autoplay rules
  video.muted = true;

  toggle.addEventListener("click", function() {
    if (video.muted) {
      video.muted = false;
      toggle.textContent = "Mute";
    } else {
      video.muted = true;
      toggle.textContent = "Unmute";
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
